import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const IndoorBanners = () => {

    const servicesFaqData = [
        {
            question: "What customisation options are available for indoor banners?",
            answer: "Printingy offers custom sizes, finishes, and materials for custom banner printing indoors. You can include high-quality logos, graphics, and messaging, with options for matte or glossy finishes to suit your display needs."
        },
        {
            question: "What industries benefit from indoor banner printing services?",
            answer: "Our indoor banners printing services are widely used in retail, corporate offices, events, education, and hospitality. Businesses rely on flex printing design indoors to enhance branding, communicate promotions, and showcase messaging effectively."
        },
        {
            question: "What materials are used for indoor banners?",
            answer: "We use lightweight, durable materials like vinyl and fabric for indoor banners printing. These materials ensure sharp graphics, easy handling, and fade resistance, making them ideal for prolonged indoor use."
        },
        {
            question: "Can Printingy handle bulk orders for indoor banners?",
            answer: "Yes, Printingy specialises in bulk custom banner printing indoor, ensuring consistent quality, cost savings, and timely delivery for large-scale orders. Bulk printing is perfect for trade shows, retail promotions, and corporate events."
        },
        {
            question: "Does Printingy provide design assistance for indoor banners?",
            answer: "Absolutely. Our flex printing design indoor services include professional design assistance. Whether you need creative input or help to finalise your layout, our expert team ensures visually appealing and impactful banners."
        },
        {
            question: "What is the typical turnaround time for indoor banners printing?",
            answer: "The turnaround time for printing indoor banners depends on the order size and customisation level. Standard bulk orders are completed within a few business days, with clear timelines for large projects."
        },
        {
            question: "Are indoor banners suitable for repeated use?",
            answer: "Yes, our indoor banners printing uses high-quality, durable materials that are lightweight and easy to store. These banners are ideal for repeated use at events, promotions, and indoor displays."
        },
        {
            question: "What makes indoor banners different from outdoor banners?",
            answer: "Indoor banners are designed for controlled environments and often use lightweight materials with sharp graphics and vivid colours. Unlike outdoor banners, custom banner printing indoor focuses more on aesthetics than weather resistance."
        },
        {
            question: "How do I place an order for custom indoor banner printing?",
            answer: "To order indoor banner printing, visit our website, select your size, material, and customisation preferences, and upload your artwork. Our team will assist you from design approval to delivery."
        },
        {
            question: "What makes bulk indoor banner printing cost-effective?",
            answer: "Bulk custom banners printing indoor reduces per-unit costs, providing excellent value for businesses needing multiple banners. By streamlining production, Printingy ensures consistent quality and competitive pricing for large orders."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Indoor Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Indoor Banners Printing Services for Promotions"
  description="Professional indoor banner printing services with custom designs. Bulk flex printing for indoor banners, interior design printing, and vibrant custom solutions."
  keywords="Indoor Banners,
Indoor Banners Printing,
Flex Printing Design Indoor,
Interior Design Printing,
Printing for Indoor Banners,
Custom Banners Printing Indoor"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Indoor Banners Printing</h1>
              <h2 className="text-muted">
              Custom banners and flex printing design for indoor displays
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Indoor banners are ideal for marketing campaigns, corporate events, and interior displays, offering vibrant visuals that enhance your branding. Printingy specialises in Indoor banner solutions, providing top-quality indoor banner printing, flex printing design indoor, and custom banner printing indoor tailored to your needs.</p>
          <p>Our services include interior design printing, ensuring banners with exceptional clarity, sharp graphics, and premium finishes that align with your branding goals. We guarantee durable, eye-catching indoor banners designed for maximum impact, whether for retail spaces, trade shows, or corporate interiors.</p>
          <p>With bulk printing capabilities, Printingy ensures reliable, cost-effective solutions combining precision, creativity, and on-time delivery for all indoor banner needs.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Indoor Banner Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and professional banners for indoor use</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert indoor banner printing for events, retail, and corporate spaces.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom banners printing indoor for cost-effective promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional flex printing design indoor with vibrant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-quality interior design printing tailored to branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable, lightweight, and fade-resistant materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for sharp details and colour consistency.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for large and customised bulk orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for events, retail, trade shows, and corporate branding.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/indoorbanner.jpg" // Path relative to the public folder
                  alt="Interior design printing for indoor displays"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Indoor Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your indoor banner printing needs</h3>
            <p>At Printingy, we combine advanced technology and durable materials to deliver superior indoor banner printing services. Whether you need flex printing design indoors for trade shows or custom banners printing indoors for events, we ensure professional results that exceed expectations.</p>
            <p>Our streamlined processes and attention to detail guarantee timely delivery for bulk orders. Printingy is your trusted partner for reliable indoor banner printing solutions that enhance branding and visibility.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default IndoorBanners;
